<template>
  <div class="mb-4 border-b border-gray-200 dark:border-gray-700">
    <ul class="flex flex-wrap -mb-px text-sm font-medium text-center" id="myTab" data-tabs-toggle="#myTabContent" role="tablist">
      <li class="mr-2" role="presentation">
        <button class="inline-block p-4 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300" 
                id="shippingMethod-tab" data-tabs-target="#shippingMethod" type="button" 
                role="tab" aria-controls="shippingMethod" :aria-selected="ariaSelected('1')">Moyens d'expédition</button>
      </li>
      <li class="mr-2" role="presentation">
        <button class="inline-block p-4 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300" id="backOffice-tab" data-tabs-target="#backOffice" type="button"
                role="tab" aria-controls="backOffice" :aria-selected="ariaSelected('2')">Utilisateurs du Back-office</button>
      </li>
      <li class="mr-2" role="presentation">
        <button @click="redirectToLegacySupplier()" class="inline-block p-4 border-b-2 rounded-t-lg" id="order-tab"
                data-tabs-target="#order" type="button" role="tab" aria-controls="order"
                :aria-selected="ariaSelected('3')">Commandes</button>
      </li>
    </ul>
  </div>
  <div id="myTabContent">
    <div class="hidden p-4 rounded-lg bg-gray-50 dark:bg-gray-800" id="order" role="tabpanel" aria-labelledby="order-tab">
      Commandes in progress...
    </div>
    <div class="hidden p-4 rounded-lg bg-gray-50 dark:bg-gray-800" id="shippingMethod" role="tabpanel" aria-labelledby="shippingMethod-tab">
      <PageShippingMethod :key="`${reloadKey}`"></PageShippingMethod>
    </div>
    <div class="hidden p-4 rounded-lg bg-gray-50 dark:bg-gray-800" id="backOffice" role="tabpanel" aria-labelledby="backOffice-tab">
      <BackOfficeSupplierList :key="`${reloadKey}`"></BackOfficeSupplierList>
    </div>
  </div>
</template>

<script setup lang="ts">
import { initFlowbite } from 'flowbite'
import { onMounted, ref, watch } from "vue";
import PageShippingMethod from "@/views/admin/supplier/shippingMethod/PageShippingMethod.vue";
import BackOfficeSupplierList from "@/views/admin/supplier/backOfficeSupplier/BackOfficeSupplierList.vue";
import { useRoute } from "vue-router";

const route = useRoute();
const reloadKey = ref(0);
const ariaSelectedFromUrl = route.params.ariaSelected ? route.params.ariaSelected.toString() : "1";
const ariaSelected = (index) => {
  return index.toString() === ariaSelectedFromUrl.toString();
}

const reloadChildComponent = () => {
  reloadKey.value += 1;
}
const supplierUuid = ref<string>("");
const redirectToLegacySupplier = () => {
    window.location.href = `${process.env.VUE_APP_LEGACY_URL}admin/suppliers/${supplierUuid.value}/orders`;
}
onMounted(() => {
  supplierUuid.value = route.params.uuid as string;
  initFlowbite();
})

watch(() => route.fullPath, () => {
  reloadChildComponent();
});
</script>